import { useTranslation } from 'react-i18next';
import type { VendorPersonType } from '@econtractor/types';
import VendorPersonAction from '../VendorPersonAction';

interface VendorPersonsTableRowProps {
    row: VendorPersonType;
    onEdit: (row: VendorPersonType) => void;
    onDelete: (row: VendorPersonType) => void;
    onOpenContacts: (row: VendorPersonType) => void;
}

const VendorPersonsTableRow = ({ row, onEdit, onDelete, onOpenContacts }: VendorPersonsTableRowProps) => {
    const { t } = useTranslation(['Vendors']);

    return (
        <tr>
            <td
                className="name cursor-pointer"
                title={t('persons.contactsHint')}
                onClick={() => onOpenContacts(row)}
            >
                <div className="text-truncate" title={row.fullName || undefined}>
                    {row.fullName || '-'}
                </div>
                {row.description ? (
                    <small className="text-muted d-block text-truncate" title={row.description}>
                        {row.description}
                    </small>
                ) : null}
            </td>
            <td className="status">
                <span className="d-block text-truncate" title={row.position || undefined}>
                    {row.position || '-'}
                </span>
            </td>
            <td className="action">
                <VendorPersonAction row={row} onEdit={onEdit} onDelete={onDelete} />
            </td>
        </tr>
    );
};

export default VendorPersonsTableRow;
